import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.25 14.75H11.75C12.5784 14.75 13.25 14.0784 13.25 13.25V5.46604C13.25 5.32817 13.1931 5.19642 13.0927 5.10194L9.14439 1.3859C9.05164 1.29861 8.92908 1.25 8.80171 1.25H4.25C3.42157 1.25 2.75 1.92157 2.75 2.75V13.25C2.75 14.0784 3.42157 14.75 4.25 14.75Z"
            fill="#C2EBD8"
            stroke="#397E54"
            strokeWidth="0.75"
        />
        <path
            d="M8.75 1.25V5C8.75 5.27614 8.97386 5.5 9.25 5.5H13.25"
            stroke="#397E54"
            strokeWidth="0.75"
        />
        <rect
            height="4.5"
            rx="0.75"
            stroke="#469565"
            strokeWidth="0.5"
            width="7.5"
            x="4.25"
            y="8.75"
        />
        <rect
            fill="#397E54"
            height="0.25"
            rx="0.125"
            stroke="#469565"
            strokeWidth="0.25"
            width="7.25"
            x="4.375"
            y="7.125"
        />
        <rect
            fill="#397E54"
            height="0.25"
            rx="0.125"
            stroke="#469565"
            strokeWidth="0.25"
            width="2.75"
            x="4.375"
            y="5.125"
        />
        <rect
            fill="#397E54"
            height="0.25"
            rx="0.125"
            stroke="#469565"
            strokeWidth="0.25"
            width="2.75"
            x="4.375"
            y="4.125"
        />
        <rect
            fill="#397E54"
            height="0.25"
            rx="0.125"
            stroke="#469565"
            strokeWidth="0.25"
            width="2.75"
            x="4.375"
            y="3.125"
        />
    </svg>
);

export default Icon;
